import React from "react";
import { FieldValues, UseFormRegister, FieldError, Path } from "react-hook-form";
import clsx from "clsx";

import { getClassByVariant } from "helpers/getClassByVariant";
import styles from "./style.module.scss";

interface IProps<T extends FieldValues>
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  name?: Path<T>;
  register?: UseFormRegister<T>;
  rows?: number;
  label?: string | React.ReactNode;
  className?: string;
  inputClass?: string;
  labelClass?: string;
  disabled?: boolean;
  error?: FieldError;
  color?: "primary" | "secondary";
}

export default function Textarea<T extends FieldValues>({
  name,
  register,
  label,
  rows = 2,
  className,
  inputClass,
  labelClass,
  disabled,
  error,
  color = "primary",
  ...props
}: Readonly<IProps<T>>) {
  return (
    <div className={clsx(styles.smartTextareaContainer, className)}>
      {label && (
        <label
          className={clsx(styles.smartTextareaLabel, labelClass, getClassByVariant(color)?.label)}>
          {label}
        </label>
      )}
      <div className={styles.smartTextareaWrapper}>
        <textarea
          rows={rows}
          className={clsx(
            styles.smartTextarea,
            inputClass,
            getClassByVariant(color)?.input,
            !!disabled && "cursor-not-allowed bg-inputDark",
            !!error && "!border-b-error"
          )}
          disabled={disabled}
          {...(register && name && register(name))}
          {...props}
        />
      </div>
      {error && <span className={styles.smartTextareaError}>{error.message}</span>}
    </div>
  );
}
